import { render, staticRenderFns } from "./MdPatientAllergiesOutCome.vue?vue&type=template&id=780feeec&"
import script from "./MdPatientAllergiesOutCome.vue?vue&type=script&lang=js&"
export * from "./MdPatientAllergiesOutCome.vue?vue&type=script&lang=js&"
import style0 from "./MdPatientAllergiesOutCome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports